import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-logo-field',
  templateUrl: './logo-field.component.html',
  styleUrls: ['./logo-field.component.scss']
})
export class LogoFieldComponent implements OnChanges, OnDestroy {

  @Input() logo: Blob | null = null;
  @Input() editable = true;
  @Input() loading = false;
  @Input() busy = false;
  @Input() error = '';
  @Output() selected = new EventEmitter<Blob>();

  previewUrl: SafeUrl | null = null;
  sizeError = '';
  private objectUrl = '';
  private readonly maxSize = 2 * 1024 * 1024;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnChanges() {
    this.revokePreview();
    this.objectUrl = this.logo ? URL.createObjectURL(this.logo) : '';
    //Angular חוסם כתובות blob ב-src ללא סימון מפורש
    this.previewUrl = this.objectUrl ? this.sanitizer.bypassSecurityTrustUrl(this.objectUrl) : null;
  }

  ngOnDestroy() {
    this.revokePreview();
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files && input.files[0];
    input.value = '';
    if (!file) {
      return;
    }
    this.sizeError = file.size > this.maxSize ? 'גודל הלוגו המקסימלי הוא 2MB' : '';
    if (!this.sizeError) {
      this.selected.emit(file);
    }
  }

  private revokePreview() {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
    }
  }
}
